import React from 'react';
import Button from '@mui/material/Button';

const ButtonCustom = ({
    variant = "outlined",
    color = "primary",
    label,
    startIcon,
    endIcon,
    disabled = false,
    sx,
    onClickBtn
}) => {

    const onButtonClicked = () => {
        if(onClickBtn){
            onClickBtn();
        }
    }

    return (
        <Button
            variant={variant}
            color={color}
            endIcon={endIcon}
            startIcon={startIcon}
            disabled={disabled}
            sx={sx}
            onClick={onButtonClicked}
            size={"large"}
        >
            {label}
        </Button>
    )

}

export default ButtonCustom;